import format from "date-fns/format";
import { useEffect, useState } from "react";

const umbracoLocaleToDateFnsLocale = (locale: string): string => {
  const [keepLowercase, toUpperCase] = locale.split("-");

  // spotted in node_modules - only locale package with a weird name
  if (toUpperCase && toUpperCase === "Latn") {
    return [keepLowercase, toUpperCase].join("-");
  }

  if (toUpperCase) {
    return [keepLowercase, toUpperCase.toUpperCase()].join("-");
  }

  return keepLowercase;
};

const lazyLoad = (locale: string) =>
  import(
    /* webpackMode: "lazy", webpackChunkName: "df-[index]", webpackExclude: /_lib/ */
    `date-fns/locale/${umbracoLocaleToDateFnsLocale(locale)}/index.js`
  ).then((module) => {
    return module.default;
  });

export const formatDate = async (
  date: string | number | Date,
  formatStyle: string,
  locale = "en-US"
): Promise<string> => {
  let _date: number | Date;

  if (typeof date === "string") {
    _date = new Date(date);
  } else {
    _date = date;
  }

  const formatter = await lazyLoad(locale);

  return format(_date, formatStyle, {
    locale: formatter,
  });
};

export const useDateFormatter = (
  date: string | number | Date,
  formatStyle: string,
  locale = "en-US"
) => {
  const [formattedDate, setFormattedDate] = useState<string>();

  useEffect(() => {
    async function init() {
      formatDate(date, formatStyle, locale).then((v) => {
        setFormattedDate(v);
      });
    }

    init();
  }, [date, formatStyle, locale]);

  return formattedDate;
};
